import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfd63064"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "living-people-category" }
const _hoisted_2 = { class: "category-header" }
const _hoisted_3 = { class: "category-count" }

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { Person } from '@webapp/rd/ResearchDataModel'
import { Collapse } from 'bootstrap'
import { remove } from 'lodash'
import { RelationshipCategory, getRelationshipCategoryText } from './LivingWindowGroups'
import { useSyncSessionStore } from './SyncSessionStore'
import ExpandButton from '@webapp/util/ExpandButton.vue'
import Checkbox from '@webapp/util/Checkbox.vue'
import LivingPersonListItem from './LivingPersonListItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LivingPeopleCategory',
  props: {
    category: {},
    persons: {},
    sessionId: {}
  },
  setup(__props: any) {

const props = __props;



const syncSessionStore = useSyncSessionStore()
const stateRef = computed(() => syncSessionStore.getState(props.sessionId))

const selectedPersonIdsRef = computed(() => {
  const ids = new Set<string>()
  const graph = stateRef.value?.sourceGraph
  if (graph) {
    for (const id of graph.mappedPersonIds) {
      ids.add(id)
    }
  }
  for (const id of stateRef.value?.livingWindowPersonIds ?? []) {
    ids.add(id)
  }
  return ids
})

const expandedRef = ref(false)
const listElemRef = ref<HTMLElement>()

const selectedRef = computed({
  get: () => {
    if (!props.persons?.length) {
      return false
    }
    const selectedCount = props.persons.filter(p => selectedPersonIdsRef.value.has(p.id!)).length
    const totalCount = props.persons.length
    return selectedCount == 0 ? false : selectedCount == totalCount ? true : undefined
  },
  set: value => {
    const includeIds = stateRef.value?.livingWindowPersonIds
    if (!includeIds) {
      return
    }
    if (value) {
      const alreadySelected = selectedPersonIdsRef.value
      const alreadyIncluded = new Set(includeIds)
      props.persons
        .filter(p => !alreadySelected.has(p.id!) && !alreadyIncluded.has(p.id!))
        .forEach(p => includeIds.push(p.id!))
    }
    else {
      const idsToRemove = new Set(props.persons.map(p => p.id!))
      remove(includeIds, id => idsToRemove.has(id))
    }
  },
})

const disabledRef = computed(() => {
  const mapped = stateRef.value?.sourceGraph?.mappedPersonIds
  return !props.persons.some(p => !mapped?.has(p.id!))
})

function toggleExpandList() {
  if (props.persons.length > 0) {
    expandedRef.value = !expandedRef.value
  }
}

onMounted(() => listElemRef.value?.addEventListener('shown.bs.collapse', onShown))
onUnmounted(() => listElemRef.value?.removeEventListener('shown.bs.collapse', onShown))

watch(expandedRef, () => {
  const c = Collapse.getOrCreateInstance(listElemRef.value!)
  c.toggle()
})

function onShown() {
  const nthItem = listElemRef.value?.querySelector('li:nth-child(5)')
  const lastItem = listElemRef.value?.querySelector('li:last-child')
  const scrollToItem = nthItem ?? lastItem
  if (scrollToItem) {
    scrollToItem.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ExpandButton, {
        hidden: !props.persons.length,
        expanded: expandedRef.value,
        "onUpdate:expanded": _cache[0] || (_cache[0] = ($event: any) => ((expandedRef).value = $event))
      }, null, 8, ["hidden", "expanded"]),
      _createVNode(Checkbox, {
        checked: selectedRef.value,
        "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((selectedRef).value = $event)),
        disabled: disabledRef.value
      }, null, 8, ["checked", "disabled"]),
      _createElementVNode("div", {
        role: "button",
        onClick: toggleExpandList
      }, [
        _createTextVNode(_toDisplayString(_unref(getRelationshipCategoryText)(props.category)) + " ", 1),
        _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(props.persons.length) + ")", 1)
      ])
    ]),
    _createElementVNode("ul", {
      ref_key: "listElemRef",
      ref: listElemRef,
      class: "list-unstyled collapse"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.persons, (p) => {
        return (_openBlock(), _createElementBlock("li", {
          key: p.id
        }, [
          _createVNode(LivingPersonListItem, {
            person: p,
            "session-id": _ctx.sessionId
          }, null, 8, ["person", "session-id"])
        ]))
      }), 128))
    ], 512)
  ]))
}
}

})